var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markup-description",domProps:{"innerHTML":_vm._s(_vm.markedDescription)}},[_vm._v(" "+_vm._s(_vm.markedDescription)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }